import { useState } from 'react';

import { createFileRoute, redirect } from '@tanstack/react-router';
import { PaginationState } from '@tanstack/react-table';

import { DEFAULT_PAGE_INDEX } from '@/app/constants/pagination';
import { RoleEnum } from '@/app/enums/RoleEnum';
import { Button } from '@/common/components/elements/button';
import { Title } from '@/common/components/elements/title';
import { Can } from '@/common/components/features/role-management';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/common/components/modules/tabs';
import { CreateProjectManager } from '@/modules/projects/components/create-project-manager';
import { ProjectList } from '@/modules/projects/components/project-list';
import { useGetAllProjectsQuery } from '@/modules/projects/queries/use-get-all-projects-query';

const redirectToHome = (): never => {
  throw redirect({
    to: '/',
  });
};

const PAGE_SIZE = import.meta.env.MODE === 'test' ? 3 : 10;

const SystemManager = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: PAGE_SIZE,
  });

  const { data: projects, isLoading: isLoadingProjects } = useGetAllProjectsQuery({
    page: pagination.pageIndex,
    pageSize: pagination.pageSize,
  });

  return (
    <div className='flex flex-col max-h-sidebar-h overflow-y-auto w-full p-5 mb:p-10'>
      <div className='flex flex-col w-full h-full gap-6'>
        <div className='flex flex-col gap-3'>
          <Title>Central</Title>
        </div>

        <Tabs defaultValue='projects' className='w-full gap-6'>
          <TabsList>
            <Can I='manage' an='Project'>
              <TabsTrigger value='projects'>Projetos</TabsTrigger>
            </Can>
            {/* <Can I='manage' an='Integrations'>
              <TabsTrigger value='integrations'>Integrações</TabsTrigger>
            </Can> */}
          </TabsList>
          <TabsContent value='projects' className='flex flex-col gap-2'>
            <div className='flex items-center justify-end'>
              <Can I='create' a='Project'>
                <CreateProjectManager>
                  {({ open }) => (
                    <Button animated size='small' variant='primary' onClick={open}>
                      Criar novo
                    </Button>
                  )}
                </CreateProjectManager>
              </Can>
            </div>
            <ProjectList
              data={projects?.data}
              pagination={pagination}
              loading={isLoadingProjects}
              setPagination={setPagination}
              totalItems={projects?.totalItems}
            />
          </TabsContent>
          <TabsContent value='integrations'>
            <p>Integrações</p>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/_app/_dashboard/central')({
  beforeLoad: ({ context }) => {
    const { auth } = context;

    if (auth.user?.role === undefined || auth.user?.role !== RoleEnum.ADMIN_MASTER) {
      redirectToHome();
    }
  },
  head: () => ({
    meta: [
      {
        title: 'Central | Podcast AI',
      },
    ],
  }),
  component: SystemManager,
});
